import { useEffect } from 'react'
import { createPortal } from 'react-dom'
import { FiX } from 'react-icons/fi'
import AuthImage from '../AuthImage/AuthImage'
import './ImageLightbox.css'

function ImageLightbox({ src, alt, caption, onClose }) {
    useEffect(() => {
        if (!src) return
        const onKey = (e) => { if (e.key === 'Escape') onClose() }
        document.addEventListener('keydown', onKey)
        return () => document.removeEventListener('keydown', onKey)
    }, [src, onClose])

    if (!src) return null

    // Portal direto no <body>: renderizado dentro de um card que pode estar
    // dentro de um modal (já portalizado), então precisa competir no mesmo
    // stacking context raiz — mesmo motivo do Modal e da Message.
    return createPortal(
        <div className="ilb-overlay" onClick={onClose}>
            <button type="button" className="ilb-close" onClick={onClose}>
                <FiX size={22} />
            </button>
            <div className="ilb-frame" onClick={(e) => e.stopPropagation()}>
                <AuthImage className="ilb-img" src={src} alt={alt} />
            </div>
            {caption && (
                <p className="ilb-caption" onClick={(e) => e.stopPropagation()}>{caption}</p>
            )}
        </div>,
        document.body
    )
}

export default ImageLightbox
